export default __webpack_public_path__ + "static/sig_compare_comp3_active-661164031a3cf71d7bc63b6a43b430d2.png";